import React, { useRef, memo } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 px-4 md:px-6 max-w-4xl mx-auto" data-id="element-100">
      <div className="text-center mb-16" data-id="element-101">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-102">
          Why most coupon books don't work
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        delay: 0.1
      }} className="text-lg text-warm-gray max-w-2xl mx-auto" data-id="element-103">
          Let’s be honest: you’ve probably seen coupon books before. They
          usually fail for one of three reasons:
        </motion.p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-104">
        {['They’re generic and feel like a novelty', 'They pick activities that don’t fit real life', 'They get shoved in a drawer because there’s no next step'].map((reason, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        delay: 0.2 + i * 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm border border-stone-100 relative" data-id="element-105">
            <span className="absolute -top-4 -left-4 w-8 h-8 bg-coral text-white rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-106">
              {i + 1}
            </span>
            <p className="text-charcoal font-medium pt-2" data-id="element-107">{reason}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={isInView ? {
      opacity: 1,
      scale: 1
    } : {
      opacity: 0,
      scale: 0.95
    }} transition={{
      delay: 0.5,
      duration: 0.6
    }} className="bg-charcoal text-white p-8 md:p-12 rounded-3xl shadow-xl" data-id="element-108">
        <h3 className="text-2xl font-serif font-bold text-center mb-8 text-cream" data-id="element-109">
          This isn't "a cute idea." It's a tiny system.
        </h3>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-8" data-id="element-110">
          <div className="bg-white/10 px-6 py-3 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-111">
            <span className="font-bold text-lg" data-id="element-112">Chosen</span>
          </div>
          <ArrowRight className="text-teal w-6 h-6 transform rotate-90 md:rotate-0" data-id="element-113" />
          <div className="bg-white/10 px-6 py-3 rounded-lg backdrop-blur-sm border border-white/20" data-id="element-114">
            <span className="font-bold text-lg" data-id="element-115">Scheduled</span>
          </div>
          <ArrowRight className="text-teal w-6 h-6 transform rotate-90 md:rotate-0" data-id="element-116" />
          <div className="bg-teal text-charcoal px-6 py-3 rounded-lg font-bold shadow-lg transform scale-110" data-id="element-117">
            <span className="text-lg" data-id="element-118">Redeemed</span>
          </div>
        </div>

        <p className="text-center text-xl md:text-2xl font-serif italic text-cream/90" data-id="element-119">
          "That’s the difference between paper and memories."
        </p>
      </motion.div>
    </section>;
}